import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import { AnimatePresence } from 'framer-motion';
import FuzzyText from './FuzzyText';

const HeaderContainer = styled(motion.header)`
  position: fixed;
  top: 20px;
  left: 30%;
  transform: translateX(-50%);
  z-index: 1000;
  background: ${props => props.scrolled ? 'rgba(0, 0, 0, 0.9)' : 'rgba(0, 0, 0, 0.3)'};
  backdrop-filter: blur(${props => props.scrolled ? '25px' : '10px'});
  -webkit-backdrop-filter: blur(${props => props.scrolled ? '25px' : '10px'});
  border: 1px solid ${props => props.scrolled ? 'rgba(0, 255, 0, 0.4)' : 'rgba(0, 255, 0, 0.2)'};
  border-radius: 50px;
  padding: 0 1.5rem;
  width: 700px;
  box-shadow: ${props => props.scrolled ? '0 8px 32px rgba(0, 0, 0, 0.6)' : '0 4px 16px rgba(0, 0, 0, 0.2)'};
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
    padding: 0 1rem;
    top: 15px;
    border-radius: 25px;
  }
  
  @media (max-width: 480px) {
    width: 100%;
    max-width: 280px;
    padding: 0 0.8rem;
    border-radius: 20px;
   
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100%;
  position: relative;
  
  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 0;
    gap: 0.5rem;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex: 1;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(motion.a)`
  color: ${props => props.scrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.9)'};
  text-decoration: none;
  font-weight: 500;
  font-size: 0.8rem;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
  white-space: nowrap;
  flex-shrink: 0;
  text-shadow: ${props => props.scrolled ? '0 1px 2px rgba(0, 0, 0, 0.5)' : 'none'};
  
  &:hover {
    background: rgba(0, 255, 0, 0.15);
    color: #00ff00;
    transform: translateY(-1px);
  }

  &.active {
    background: rgba(0, 255, 0, 0.2);
    color: #00ff00;
    box-shadow: 0 2px 8px rgba(0, 255, 0, 0.2);
  }

  &:focus {
    outline: 2px solid rgba(0, 255, 0, 0.5);
    outline-offset: 2px;
    border-radius: 20px;
  }
  
  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
  }
`;

const AnimatedName = styled(motion.div)`
  position: fixed;
  top: 30px;
  left: 30px;
  z-index: 1001;
  font-size: 1.5rem;
  font-weight: 700;
  color: #00ff00;
  text-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
  cursor: pointer;
  opacity: ${props => props.scrolled ? '1' : '0.8'};
  transition: opacity 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    top: 30px;
    left: 15px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.4rem;
    top: 30px;
    left: 15px;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: ${props => props.scrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.9)'};
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  position: absolute;
  right: 0;
  flex-shrink: 0;
  z-index: 1002;
  
  &:hover {
    background: rgba(0, 255, 0, 0.1);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    position: relative;
    right: auto;
    font-size: 1.1rem;
    padding: 0.3rem;
  }
  
  @media (max-width: 480px) {
    width: 30px;
    height: 30px;
    font-size: 1rem;
    padding: 0.2rem;
  }
`;

const MobileMenu = styled(motion.div)`
  position: fixed;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  border: 1px solid rgba(0, 255, 0, 0.3);
  border-radius: 20px;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  min-width: 220px;
  max-width: 320px;
  width: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 1001;

  @media (min-width: 769px) {
    display: none;
  }
  
  @media (max-width: 480px) {
    top: 80px;
    min-width: 150px;
    max-width: 300px;
    padding: 1rem;
    border-radius: 15px;
    gap: 0.6rem;
  }
`;

const MobileMenuOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 1000;
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileNavLink = styled(motion.a)`
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  padding: 0.8rem 1.2rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  font-size: 1rem;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  
  &:hover {
    background: rgba(0, 255, 0, 0.15);
    color: #00ff00;
    transform: translateX(5px);
  }

  &.active {
    background: rgba(0, 255, 0, 0.25);
    color: #00ff00;
    box-shadow: 0 2px 8px rgba(0, 255, 0, 0.2);
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  @media (max-width: 480px) {
    padding: 0.7rem 1rem;
    font-size: 0.9rem;
    border-radius: 10px;
  }
`;

const MobileNavPlaceholder = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    width: 35px;
    height: 35px;
  }
  
  @media (max-width: 480px) {
    width: 30px;
    height: 30px;
  }
`;

const Header = ({ currentSection }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navItems = [
    { href: '#home', label: 'Home' },
    { href: '#about', label: 'About' },
    { href: '#experience', label: 'Experience' },
    { href: '#skills', label: 'Skills' },
    { href: '#projects', label: 'Projects' },
    { href: '#education', label: 'Education' },
    { href: '#contact', label: 'Contact' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <AnimatedName
        scrolled={scrolled}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        whileHover={{ scale: 1.05, textShadow: "0 0 30px rgba(0, 255, 0, 0.8)" }}
        whileTap={{ scale: 0.95 }}
        onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}
      >
        <FuzzyText
          fontSize="1.5rem"
          fontWeight={700}
          color="#00ff00"
          baseIntensity={0.1}
          hoverIntensity={0.3}
          enableHover={true}
        >
          Anas Naveed Butt
        </FuzzyText>
      </AnimatedName>

      <HeaderContainer
        scrolled={scrolled}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <HeaderContent>
          <MobileNavPlaceholder />
          <Nav>
            {navItems.map((item) => (
              <NavLink
                key={item.href}
                href={item.href}
                scrolled={scrolled}
                className={`cursor-target ${currentSection === item.href.slice(1) ? 'active' : ''}`}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                {item.label}
              </NavLink>
            ))}
          </Nav>

          <MobileMenuButton 
            scrolled={scrolled}
            onClick={toggleMobileMenu}
            className="cursor-target"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <FiX /> : <FiMenu />}
          </MobileMenuButton>
        </HeaderContent>
      </HeaderContainer>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <>
            <MobileMenuOverlay
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={closeMobileMenu}
            />
            <MobileMenu
              initial={{ opacity: 0, y: -20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -20, scale: 0.95 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            >
              {navItems.map((item, index) => (
                <MobileNavLink
                  key={item.href}
                  href={item.href}
                  className={`cursor-target ${currentSection === item.href.slice(1) ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  whileHover={{ x: 5 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {item.label}
                </MobileNavLink>
              ))}
            </MobileMenu>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
